module.exports = __webpack_public_path__ + "img/hr-cliff-outer.1050eb3f.png";